import Vue from 'vue';
import Vuex from 'vuex';
import DetectOS from 'detectos.js';
import store from '~/store';
import { eventBus } from '~/app';
import utils from '../../helpers/utils';
import router from '../../router';
import constants from 'Helpers/constants';

const Detect = new DetectOS();

Vue.use(Vuex);
const vm = new Vue();

export default {
    // namespaced: true,
    state: {
        socket: {
            isConnected: false,
            message: '',
            reconnectError: false,
        },

        userData: {},
        timerId: null,
        lastPongAt: new Date(),
    },
    mutations: {
        SOCKET_ONOPEN(state, event) {
            Vue.prototype.$socket = event.currentTarget;
            state.socket.isConnected = true;

            console.log('The websocket is ready to use');

            let data = {
                //uniqAppId: this.getters['getUniqAppId'],
                browser: Detect.browser + ' ' + Detect.version,
                os: Detect.OS,
                ...state.userData,
                //pageUrl: window.location.toString(),
            };

            this.dispatch('sendObj', {
                event: 'updateUserData',
                data: data,
            });
            // Vue.prototype.$socket.sendObj({
            //     event: 'updateUserData',
            //     data: data,
            // });

            if (utils.getPlatform() !== constants.PLATFORM_TRADEBALL) {
                //for bet-bra/apostas after success login we need to send "appReady", better to do it after socket connected
                let message = JSON.stringify({
                    type: 'appReady',
                });

                console.log('Send msg to parent: ' + message);
                window.parent.postMessage(message, '*');
            }

            this.commit('setLastPongAt', new Date());
            this.dispatch('heartbeat');
        },
        SOCKET_ONCLOSE(state) {
            console.log('The websocket is closed');

            state.socket.isConnected = false;

            if (state.timerId) {
                clearInterval(state.timerId);
                console.log('Cleared setInterval in onclose #' + state.timerId);
                state.timerId = null;
            }
        },
        SOCKET_ONERROR(state, event) {
            console.error(state, event);

            state.socket.isConnected = false;

            if (state.timerId) {
                clearInterval(state.timerId);
                console.log('Cleared setInterval in onerror #' + state.timerId);
                state.timerId = null;
            }
        },
        // default handler called for all methods
        SOCKET_ONMESSAGE(state, message) {
            let isBrowserTabInactive = null;
            let lastBrowserTabInactive = null;

            switch (message.event) {
                case 'init':
                    console.log('webSocket init: ' + message.data.message);

                    if (!message.data.isLogin && store.getters['UserModule/getUser']) {
                        console.log('Your session is expired');
                        this.dispatch('AuthModule/logout');
                    }
                    break;
                case 'pong':
                    this.commit('setLastPongAt', new Date());
                    break;
                case 'feedLiveRows':
                    isBrowserTabInactive = store.getters['AppModule/getIsBrowserTabInactive'];
                    lastBrowserTabInactive = store.getters['AppModule/getLastBrowserTabInactive'];

                    if (isBrowserTabInactive && lastBrowserTabInactive && Date.now() - lastBrowserTabInactive >= 30000) { //30 sec
                        // console.log("Message is skipped due to inactive tab");
                        return;
                    }
                    eventBus.$emit('feedLiveRowsUpdate', message.data);
                    break;
                case 'feedDballRows':
                    isBrowserTabInactive = store.getters['AppModule/getIsBrowserTabInactive'];
                    lastBrowserTabInactive = store.getters['AppModule/getLastBrowserTabInactive'];

                    if (isBrowserTabInactive && lastBrowserTabInactive && Date.now() - lastBrowserTabInactive >= 30000) { //30 sec
                        // console.log("Message is skipped due to inactive tab");
                        return;
                    }
                    eventBus.$emit('feedDballRowsUpdate', message.data);
                    break;
                case 'reload':
                    if (message.data.redirectToMain === 'true') {
                        router
                            .push({
                                name: 'feedLive',
                            })
                            .catch(() => utils.reload())
                            .then(() => utils.reload());
                    } else {
                        // window.location.reload();
                        utils.reload();
                    }
                    break;
                case 'logout':
                    this.dispatch('AuthModule/logout');
                    break;
                case 'information':
                    utils.successMessage(message.data.message ? message.data.message : message.data);
                    break;
                case 'userBalance':
                    // eventBus.$emit('updateUserBalance', message.data.balance);
                    this.commit('UserModule/setBalance', message.data.balance, {
                        root: true,
                    });
                    break;
                case 'userBotStats':
                    this.commit('BotModule/setStats', message.data.stats);
                    // eventBus.$emit('updateUserBotStats', message.data.stats);
                    break;
                case 'userOpenBets':
                    this.commit('AppModule/setBets', message.data.bets, {
                        root: true,
                    });
                    break;
                case 'userOpenOrders':
                    this.commit('AppModule/setOrders', message.data.orders, {
                        root: true,
                    });
                    break;
                case 'dictionary':
                    this.dispatch('DictionariesModule/setDictionaries', message.data.dictionary, { root: true });
                    break;
                case 'betAdded': {
                    // eventBus.$emit('addLiveBets', message.data);
                    this.dispatch('AppModule/addBet', message.data, {
                        root: true,
                    });

                    let toolUserSettings = store.getters['AppModule/getToolUserSettings'];
                    if (toolUserSettings.is_show_popup_on_bet) {
                        let info = utils.bettingInfoForMessage(message.data, true, '');
                        let msg =
                            (_.isNumber(message.data.botId)
                                ? store.$i18n.t('bet.popup.botName', {
                                      name: message.data.name,
                                  })
                                : store.$i18n.t('bet.popup.betOrderId', {
                                      id: message.data.betOrderInternalId,
                                  })) +
                            '<br>' +
                            info.gameInfo +
                            '<br>' +
                            info.betInfo;

                        utils.newBetMessage(msg);

                        if (_.isNumber(message.data.betOrderId)) {
                            eventBus.$emit('pageReload', {
                                page: 'page-order',
                            });
                        }
                    }
                    if (toolUserSettings.is_play_sound_on_bet && !document.hidden) {
                        utils.playSound('/audio/coins-falling-022-37390.mp3');
                    }
                    break;
                }
                case 'betUpdated': {
                    // eventBus.$emit('updateLiveBets', message.data);
                    this.dispatch('AppModule/updateBet', message.data, {
                        root: true,
                    });
                    break;
                }
                case 'pageReload': {
                    eventBus.$emit('pageReload', { page: message.data.page });
                    break;
                }
                case 'notifications': {
                    eventBus.$emit('updateNotifications', message.data.notification);
                    break;
                }
                case 'favoriteUpdated': {
                    this.commit('AppModule/setFavoriteEvent', message.data.rows);
                    break;
                }
                case 'favoriteLeagueUpdated': {
                    this.commit('LeagueModule/setFavoriteLeague', message.data.rows, { root: true });
                    break;
                }
                case 'favoriteTeamUpdated': {
                    this.commit('TeamModule/setFavoriteTeam', message.data.rows, { root: true });
                    break;
                }
                case 'favoriteOrderUpdated': {
                    let toolUserSettings = store.getters['AppModule/getToolUserSettings'];
                    toolUserSettings.favorite_game_order_by_id = message.data.orderById;
                    this.dispatch('UserModule/changeSettings', {
                        toolUserSettings: toolUserSettings,
                    });
                    break;
                }
                case 'updateBettingPopup': {
                    let module = '';
                    if (router.currentRoute.name === 'feedLive') {
                        module = 'FeedLiveModule';
                    } else if (router.currentRoute.name === 'feedDball') {
                        module = 'FeedDballModule';
                    } else if (router.currentRoute.name === 'favourite') {
                        module = 'BoardModule';
                    }
                    if (module) {
                        this.dispatch(module + '/updateBettingPopup', message.data);
                    }
                    this.dispatch('EventModule/updateBettingPopup', message.data);

                    break;
                }
                case 'updateEventPopup': {
                    this.dispatch('EventModule/updateEventPopup', message.data);
                    break;
                }
                case 'orderAdded': {
                    this.dispatch('AppModule/addOrder', message.data.row);
                    break;
                }
                case 'orderUpdated': {
                    this.dispatch('AppModule/updateOrder', message.data.row);
                    break;
                }
                // case 'orderClosed': {
                //     var msg = '';
                //     let color = 'greenMsg';
                //
                //     if (message.data.fillPercent === 0) {
                //         msg = store.$i18n.t('betOrder.popup.notFilled', { id: message.data.internal_id });
                //         color = 'lightRedMsg';
                //
                //         let info = utils.bettingInfoForMessage(message.data, true, '');
                //
                //         msg += info.gameInfo ? '<br>' + info.gameInfo : '' + info.betInfo ? '<br>' + info.betInfo : '';
                //     } else {
                //         if (message.data.fillPercent === 100) {
                //             msg = store.$i18n.t('betOrder.popup.fullyFilled', { id: message.data.internal_id });
                //         } else {
                //             msg = store.$i18n.t('betOrder.popup.partialFilled', {
                //                 id: message.data.internal_id,
                //                 percent: message.data.fillPercent,
                //             });
                //             color = '#92c47dcc';
                //         }
                //
                //         if (message.data.odds && message.data.odds_requested) {
                //             let oddsDiff = parseFloat(message.data.odds) - parseFloat(message.data.odds_requested);
                //             if (oddsDiff >= 0.01) {
                //                 msg +=
                //                     '<br>' +
                //                     store.$i18n.t('betOrder.popup.takenBetterOdds', {
                //                         oddsDiff: oddsDiff.toFixed(3),
                //                     });
                //             }
                //         }
                //     }
                //
                //     utils.orderClosedMessage(msg, color);
                //
                //     this.dispatch('AppModule/updateOrder', message.data);
                // }
            }
        },
        // mutations for reconnect methods
        // eslint-disable-next-line no-unused-vars
        SOCKET_RECONNECT(state, count) {
            // console.info(state, count);
            if (state.timerId) {
                clearInterval(state.timerId);
                console.log('Cleared setInterval in reconnect #' + state.timerId);
                state.timerId = null;
            }
        },
        SOCKET_RECONNECT_ERROR(state) {
            state.socket.reconnectError = true;
        },
        setLastPongAt(state, lastPongAt) {
            state.lastPongAt = lastPongAt;
            console.log('Set lastPongAt = ' + lastPongAt);
        },
    },
    actions: {
        heartbeat: function (context) {
            if (context.state.timerId) {
                clearInterval(context.state.timerId);
                console.log('Cleared setInterval in heartbeat #' + context.state.timerId);
                context.state.timerId = null;
            }
            context.state.timerId = setInterval(() => {
                let lastPongAt = context.state.lastPongAt;

                let currentDate = new Date();
                let diff = currentDate.getTime() - lastPongAt.getTime();
                let maxDiff = 3 * 60 * 1000; //3 min

                if (diff >= maxDiff) {
                    console.log('The websocket should be closed due to timeout. Diff = ' + diff + ', lastPongAt = ' + lastPongAt);
                    if (vm.$socket && vm.$socket.readyState) {
                        vm.$disconnect(); //close websocket

                        let token = context.rootState.UserModule.token;

                        vm.$connect(utils.getWebSocketURL(token));
                    }
                } else {
                    console.log('Ping. lastPongAt = ' + lastPongAt);
                    this.dispatch('sendObj', {
                        event: 'ping',
                    });
                }
            }, 30000); // 30 seconds = 30 * 1000

            console.log('Added setInterval #' + context.state.timerId);
        },
        sendMessage: function (context, message) {
            if (Vue.prototype.$socket && Vue.prototype.$socket.readyState === 1) {
                Vue.prototype.$socket.send(message);
            } else {
                console.log('Unable to send message "' + message + '" due to WS is not connected');
            }
        },
        sendObj: function (context, obj) {
            if (Vue.prototype.$socket && Vue.prototype.$socket.readyState === 1) {
                Vue.prototype.$socket.sendObj(obj);
            } else {
                console.log('Unable to send message ' + JSON.stringify(obj) + ' due to WS is not connected');
            }
        },
    },

    getters: {
        isConnected(state) {
            return state.socket.isConnected;
        },
    },
};
